export default "__VITE_ASSET__71dea1ff__"